import api from './api';

export async function login(email, password) {
    try {
        const response = await api.post('Auth/Login', { email, password });
        if (response.data) {
            localStorage.setItem('authToken', response.data);
        }
        return response.data;
    } catch (error) {
        throw error;
    }
}

export async function getRole() {
    try {
        const authToken = localStorage.getItem('authToken');
        if (!authToken) return null;

        const response = await api.get('Auth/Role', {
            headers: { Authorization: `Bearer ${authToken}` }
        });
        return response.data;
    } catch (error) {
        if (error.response && (error.response.status === 401 || error.response.status === 403)) {
            localStorage.removeItem('authToken');
        }
        return null;
    }
}

export async function isDoctor() {
    const role = await getRole();
    return role === 'Doctor' && localStorage.getItem('authToken') !== null;
} 